module.exports = __webpack_public_path__ + "static/image5percenEn.b1bdf389.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/image5percenEn.png
// module id = 1273
// module chunks = 64098118039141